export default __webpack_public_path__ + "static/media/txt.00a7dfcd.svg";